import { format, subDays } from 'date-fns'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './datepickerOverride.css'
import customLocale from './customLocale'
import CalenderHeader from './CalendarHeader'
import { change_date } from 'utils/customWebengage'

const Calendar = ({ handleOnChange, currentDate, dateObj = [], profile }) => {
    const getDateStatus = (date) => {
        if (!date || !dateObj.length) return null
        const dateString = format(date, 'yyyy-MM-dd')
        const dateInfo = dateObj.find((item) => item.date === dateString)
        return dateInfo ? dateInfo.status : null
    }

    const getDateClassName = (date) => {
        const status = getDateStatus(date)
        switch (status) {
            case 'missed':
                return 'missed-date'
            case 'results':
                return 'results-date'
            case 'upcoming':
                return 'upcoming-date'
            case 'ongoing':
                return 'results-date'
            default:
                return ''
        }
    }

    const minDate = new Date()
    const maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + 2, 0)

    return (
        <div className="custom-datepicker-wrapper">
            <DatePicker
                selected={currentDate}
                onChange={(date) => {
                    profile['month_changed'] = date
                    change_date('6_Calendar_date_click', profile, profile.exam_type)
                    if (handleOnChange) {
                        handleOnChange(date)
                    }
                }}
                inline
                minDate={minDate}
                maxDate={maxDate}
                dateFormat="dd/MM/yyyy"
                filterDate={(date) => date >= subDays(new Date(), 1)}
                onKeyDown={(e) => {
                    e.preventDefault()
                }}
                renderDayContents={(day, date) => {
                    return day
                }}
                dayClassName={(date) => getDateClassName(date)}
                locale={customLocale}
                renderCustomHeader={({
                    monthDate,
                    decreaseMonth,
                    increaseMonth,
                }) => (
                    <CalenderHeader
                        decreaseMonth={decreaseMonth}
                        increaseMonth={increaseMonth}
                        monthDate={monthDate}
                        profile={profile}
                        maxDate={maxDate}
                        minDate={minDate}
                    />
                )}
                monthsShown={1}
            />
        </div>
    )
}

export default Calendar
